// safeguard against model being different type than expected
export const getAttribute = (model, attr) => {
  // model may be a Backbone.Model or possibly a regular Object or nullish
  if (model) {
    if (typeof model.get === "function") return model.get(attr)
    if (typeof model === "object") return model[attr]
  }

  return null
}
